import {useEffect, useState, useContext} from "react";
import '../../styles/pages/resistance_overview.scss'
import * as d3 from 'd3v4'
import {scaleSequentialLog, scaleSequential} from 'd3'
import Legend from "../../components/Legend";
import WorkflowContext from "../../workflowContext";
// import { useCookies } from 'react-cookie';
import fetchOptionsBuilder from "../../fetchOptionBuilder";
import { useSearchParams } from "react-router-dom";

import { useNavigate } from "react-router-dom";

import CategoryFilterMenu from "../../components/CategoryFilterMenu";
import { Checkbox } from "primereact/checkbox";

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
        return defaultValue;
    }
    return JSON.parse(stored);

    }    


export default function ResistanceOverview() {
    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const workflow = useContext(WorkflowContext);
    const [searchParams, setSearchParams] = useSearchParams();  // eslint-disable-line no-unused-vars

    const [dataStatus, setDataStatus] = useState('none');
    const [overfiltered, setOverfiltered] = useState(false);
    const [unfilteredData, setUnfilteredData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [catValues, setCatValues] = useState(new Set());
    const [textFilter, setTextFilter] = useState(/.+/g);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [metadata, setMetadata] = useState({});
    const [shownGenes, setShownGenes] = useState(null);
    const [attributeTypes, setAttributeTypes] = useState(null);
    const [logDisplay, setLogDisplay] = useState(false);

    const navigate = useNavigate();

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));     


    // define colors for numeric scale
    const lowColor = 'blue';
    const highColor = 'red';

    // check if all values match float number regex
    let floatData = Boolean(catValues.size);
    catValues.forEach(val => {
        if (!val.match(/^[+-]?\d+(\.\d+)?$/)) {
            floatData = false;
        }
    });
    let [min, max] = [Infinity, -Infinity];
    if (floatData) {
        catValues.forEach(val => {
            const num = Number(val);
            min = Math.min(min, num);
            max = Math.max(max, num);
        })
    }
    // console.log(floatData, min, max);

    const colorScheme = [];
    if (selectedCategory) {
        const propLength = catValues.size;
        for (let i = 0; i < propLength; i++) {
            colorScheme.push(d3.interpolateRainbow(i / propLength));
        }
    }

    const color = floatData ?
        logDisplay ?     
            scaleSequentialLog().domain([min, max]).range([lowColor, highColor]) :
            scaleSequential().domain([min, max]).range([lowColor, highColor]) :
        d3.scaleOrdinal(colorScheme)
    

    useEffect(() => {
        document.title = `Phenotypes | Palmona Pathogenomics`
    }, []);

    useEffect(() => {
        //  Set the categories for the Filter list.
        setCategories([]);
        setShownGenes(null);

        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + "phenotype_categories", fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(res => {
                if (res.ok) {
                    setDataStatus('success');
                    return res.text()
                } else {
                    setDataStatus('failed')
                    throw new Error('There was no data or it was not successfully loaded');
                }
            })
            .then(cats => {
                JSON.parse(cats).forEach(category => {
                    setCategories(categories => [...categories, category])
                })
            })  // fetch
            .catch(err => {
                console.log(err.message);
            });
        
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + 'metadata/json', fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(res => res.json())
            .then(val => setMetadata(val))
            .catch(err => {
                console.error(err);
            })

        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + 'attribute_types', fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(res => res.json())
            .then(val => setAttributeTypes(val))
            .catch(err => {
                console.error(err);
            })
    }, [workflow, apitoken, getDataUserId]);

    useEffect(() => {
        const urlCategory = searchParams.get('category');
        if (urlCategory && !selectedCategory && categories.includes(urlCategory)){
            setSelectedCategory(urlCategory);
        }
        if (!selectedCategory) return;
        setDataStatus('loading');

        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + "phenotypes/csv", fetchOptionsBuilder(apitoken, workflow, getDataUserId, selectedCategory)) // TODO add route to specify the category (drug class) to pull data from
        .then(res => {
            if (res.ok) {
                setDataStatus('success');
                return res.text()
            } else {
                setDataStatus('failed');
                throw new Error('There was no data or it was not successfully loaded');
            }
        })
            .then(str => d3.csvParse(str))
            .then(data => {
                setUnfilteredData(data);
                const newCatValues = new Set();
                data.forEach(datum => {
                    newCatValues.add(datum.value);
                });
                setCatValues(newCatValues);
            })
            .catch(err => {
                console.log(err.message);
            })
    }, [apitoken, workflow, selectedCategory, getDataUserId, categories, searchParams]);

    useEffect(() => {
        if (!selectedCategory) return;
        const data = unfilteredData.filter(strain => {
            if (shownGenes && !shownGenes.has(strain.variable)) return false;
            return strain.variable.match(textFilter)
        });
        

        d3.selectAll("#resistance-chart svg").remove();

        if (!data.length && unfilteredData.length) {
            setOverfiltered(true);
            return;
        } else {
            setOverfiltered(false);
        }

        // enable to randomize data values and demonstrate heatmap
        // data.forEach(element => {
        //     element.value = String(Math.ceil(Math.random() * 100));
        // })

        // Labels of row and columns -> unique identifier of the column called 'group' and 'variable'
        var myGroups = d3.map(data, function(d){return d.group;}).keys()
        var myVars = d3.map(data, function(d){return d.variable;}).keys()
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // let maxLen = 0;
        // if (myVars.length < 50) {
        //     for (let i = 0; i < myVars.length; i++) {
        //         maxLen = Math.max(maxLen, ctx.measureText(myVars[i]).width);
        //     }
        // }

        let maxWid = 0;
        for (let i = 0; i < myGroups.length; i++) {
            maxWid = Math.max(maxWid, ctx.measureText(myGroups[i]).width)
        }

        // set the dimensions and margins of the graph
        var margin = {top: 0, right: 25, bottom: 70, left: 30};
        // if (myVars.length < 50) margin.left = Math.ceil(maxLen) + 50;
        var width = Math.max((myGroups.length * (Math.ceil(maxWid) + 50)), 200),
        height = 500 - margin.top - margin.bottom;

        // append the svg object to the body of the page
        var svg = d3.select("#resistance-chart")
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");
        

        // Build X scales and axis:
        var x = d3.scaleBand()
            .range([ 0, width ])
            .domain(myGroups)
            .padding(0.05);
        svg.append("g")
        .style("font-size", 15)
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x).tickSize(0))
        .attr("dy", ".35em")
        .select(".domain").remove()

        // Build Y scales and axis:
        var y = d3.scaleBand()
            .range([ height, 0 ])
            .domain(myVars)
            .padding(0.05);

        // if (myVars.length < 50) {
        //     svg.append("g")
        //     .style("font-size", 15)
        //     .call(d3.axisLeft(y).tickSize(0))
        //     .select(".domain").remove()
        // }
        

        // Build axis titles
        svg.append("text")
            .attr("text-anchor", "middle")
            .attr("x", width / 2)
            .attr("y", height + margin.top + 40)
            .style("font-size", 20)
            .text("Resistance Genes");

        svg.append("text")
            .attr("text-anchor", "middle")
            .attr("transform", "rotate(-90)")
            .attr("y", -margin.left+20)
            .attr("x", -margin.top - (height / 2))
            .style("font-size", 20)
            .text("Strains")
        

        // create a tooltip
        var tooltip = d3.select("#resistance-chart")
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")
            .style("background-color", "white")
            .style("position", "absolute")
            .style("border", "solid")
            .style("border-width", "2px")
            .style("border-radius", "5px")
            .style("padding", "5px")

        // Three function that change the tooltip when user hover / move / leave a cell
        var mouseover = function(d) {
            tooltip
            .style("opacity", 1)
            d3.select(this)
            .style("stroke", "black")
            .style("opacity", 1)
        }
        var mousemove = function(d) {
            tooltip
            .html(d.variable + ": " + d.value)
            .style("left", (d3.mouse(this)[0]+70) + "px")
            .style("top", (d3.mouse(this)[1]) + "px")
        }
        var mouseleave = function(d) {
            tooltip
            .style("opacity", 0)
            d3.select(this)
            .style("stroke", "none")
            .style("opacity", 0.8)
        }

        var gotolink = function (d) {
            var url = "/strains/detail/";
            url += d.variable;
            console.log(url);
            // $(location).attr('href', url);
            // window.location = url;
            navigate(url);
            }

        // add the squares
        svg.selectAll()
            .data(data, function(d) {return d.group+':'+d.variable;})
            .enter()
            .append("rect")
            .attr("x", function(d) { return x(d.group) })
            .attr("y", function(d) { return y(d.variable) })
            .attr("rx", 4)
            .attr("ry", 4)
            .attr("width", x.bandwidth() )
            .attr("height", y.bandwidth() )
            .style("fill", function(d) { return color(d.value)} )
            .style("stroke-width", 4)
            .style("stroke", "none")
            .style("opacity", 0.8)
            .on("mouseover", mouseover)
            .on("mousemove", mousemove)
            .on("mouseleave", mouseleave)
            .on("click", gotolink)

        // add the legend
        
        if (floatData) {
            const legend = new Legend(color, {
                title: 'Resistance',
                ticks: 5,
                tickFormat: tick => {
                    if (logDisplay) {
                        const digits = Math.ceil(Math.log10(tick));
                        if (!(tick % (5 * (10 ** (digits - 1))))) return tick;
                    } else {
                        return tick;
                    }   
                }
            });
            d3.select('#resistance-chart')
                .append('svg')
                .html(legend.outerHTML)
                .style('margin-left', '50px')

        } else {
            const legend = d3.select('#resistance-chart')
                .append('svg')
                .attr('width', width)
                .attr('height', 100)

            let i = 0;
            catValues.forEach(val => {
                legend.append('rect')
                    .attr('width', 40)
                    .attr('height', 20)
                    .attr("rx", 4)
                    .attr("ry", 4)
                    .style('fill', color(val))
                    .attr('x', 30 + Math.floor(i / 3) * 125)
                    .attr('y', i % 3 * 30)
                    .style("stroke-width", 4)
                    .style("stroke", "none")
                    .style("opacity", 0.8)
                legend.append('text')
                    .attr('x', 75 + Math.floor(i / 3) * 125)
                    .attr('y', 15 + i % 3 * 30)
                    .attr('text-anchor', 'start')
                    .text(val)
                i++;
            });
        
        }
        
        
    }, [textFilter, unfilteredData, shownGenes, logDisplay, floatData, catValues, selectedCategory, color, navigate]);


    return (
        <div className="screen resistance overview">
            <div className="container mt-4 text-secondary">
                <div className="row">
                    <div className="col">
                        <h1>Phenotypes Overview</h1>
                        <h2>Presence of resistance genes across strains</h2>
                        <div className="row flex-nowrap">
                            <div className="w-21rem">
                                <CategoryFilterMenu 
                                    propOptions={categories} 
                                    setSelectedProperty={data => setSelectedCategory(data)} 
                                    selectedProperty={selectedCategory} 
                                    setTextFilter={setTextFilter}
                                    metadata={metadata}
                                    shownGenes={shownGenes}
                                    setShownGenes={setShownGenes}
                                    attributeTypes={attributeTypes}
                                />
                                <div className="flex mt-2">
                                    <Checkbox onChange={e => setLogDisplay(e.checked)} checked={logDisplay}/>
                                    <p className="ml-1">Logarithmic Display for Numeric Values</p>
                                </div>
                            </div>
                            <div className="resistance-wrapper w-75">
                                {overfiltered && <p>No strains match the applied filter</p>}
                                {dataStatus === 'success' && <div id="resistance-chart"></div>}
                                {dataStatus === 'failed' && <p>Did not load data as there is none.</p>}
                                {dataStatus === 'loading' && <p>Loading data...</p>}
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    );
}
